import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import localeData from 'dayjs/plugin/localeData';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';

/**
 * Central dayjs configuration.
 *
 * The app previously used both moment (23 files) and dayjs (8 files). moment is in
 * maintenance mode and is not tree-shakeable, and — more importantly — antd v5 expects
 * dayjs objects: passing a moment instance to <DatePicker> (as several screens did) is a
 * latent bug, not just extra weight.
 *
 * dayjs keeps optional behaviour in plugins, so anything moment did out of the box has to
 * be registered once. Importing this module for its side effect (see src/index.js) makes
 * the plugins available to every plain `import dayjs from 'dayjs'` elsewhere.
 */
dayjs.extend(duration);
dayjs.extend(localeData);
dayjs.extend(customParseFormat);
dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);

export default dayjs;
